export enum Page {
    'Default Search' = 1,
    'Supplier Search',
    'Workflow Page',
}
